import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const statusColors: Record<string, string> = {
  open: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  active: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  resolved: "bg-slate-100 text-slate-800 dark:bg-slate-900 dark:text-slate-200",
  pending:
    "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  inactive: "bg-slate-100 text-slate-800 dark:bg-slate-900 dark:text-slate-200",
  suspended: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  sent: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
  failed: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  read: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
};

export function StatusBadge({ status }: { status: string }) {
  return (
    <Badge variant="outline" className={cn("text-xs", statusColors[status])}>
      {status}
    </Badge>
  );
}
